import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { instance2 } from "../utils/axiosInstance"; // Ensure the Axios instance path is correct
import CalendarIcon from "../img/calendaricon.svg"; // Replace with the correct path for your calendar icon
import { formatNumber } from "../numberingformat"; // Ensure formatNumber works for formatting
import DapurIcon from "../img/logodapursidebar.png";
import { basecode } from "./pesananscreen/baserobotocode";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
import "jspdf-autotable"; // Import the autotable plugin for jsPDF
import { useNavigate } from "react-router-dom";

export default function PenerimaanDO() {
  const navigate = useNavigate();
  const [locationId, setLocationId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [editableRows, setEditableRows] = useState({});

    // Access state from the navigate call
    const location = useLocation();
  
    // Extract startDate and endDate from the URL query string
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const dateParam = queryParams.get('dateParam');
  
    const [selectedDate, setSelectedDate] = useState(new Date(startDate));
  
const localDateString = (thedate) =>{

  const year = thedate.getFullYear();
  const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
  const day = String(thedate.getDate()).padStart(2, '0');
  
console.log("startDate", thedate);
const localDateString = `${year}-${month}-${day}`;

return localDateString

}
  const getWeekStartAndEndDates = (date) => {
    const current = new Date(date);
    const dayOfWeek = current.getDay();
    const monday = new Date(selectedDate? selectedDate : current);
    monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return { startDate: localDateString(monday), endDate: localDateString(sunday)};
  };

  //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);

  useEffect(() => {
    const storedLocationId = localStorage.getItem("locationId");
    if (storedLocationId && !isNaN(storedLocationId)) {
      const parsedId = parseInt(storedLocationId, 10);
      setLocationId(parsedId);
    }
  }, []);

  useEffect(() => {
    const fetchDataForDate = async (date) => {
      if (!locationId) {
        console.log("Location ID not yet available.");
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await instance2.get(`delivery_order/kitchen/${localStorage.getItem("kitchenId")}`);
        const retrievedData = response.data?.data || response.data || [];
        //console.log(`draft_do/${locationId}/${localDateString(new Date(selectedDate))}/${localDateString(new Date(selectedDate))}`)
        setData(retrievedData.filter(d => d.kitchen_id === parseInt(localStorage.getItem("kitchenId"),10) && localDateString(new Date(d.delivery_date)) === localDateString(new Date(selectedDate))));
        const filtered = retrievedData.filter(d => d.kitchen_id === parseInt(localStorage.getItem("kitchenId"),10) && localDateString(new Date(d.delivery_date)) === localDateString(new Date(selectedDate)))
        console.log("dates", parseInt(localStorage.getItem("kitchenId"),10),  localDateString(new Date(selectedDate)), data, "retrieve:",retrievedData, filtered)

        // Set editable rows state
        const initialEditableState = filtered.reduce((acc, item, index) => {
          acc[index] = {
            date_request: item.delivery_date,
            ingredient_id: item.ingredient_id,
            kitchen_id: item.kitchen_id,
            ingredient_value: item.qty,
            qty_request: item.qty,
            qty: item.qty,
            id: item.id,
            order_qty: item.order_qty,
            // ingredient_value: item.ingredient_value,
            edited_qty: item.qty, // Initially, set it to ingredient_value
            remaining_qty: item.qty - (item.ingredient_value?? 0), // Remaining qty after ingredient value is set
            qty_received: item.qty,
            // remaining_qty: item.qty_received - item.ingredient_value, // Remaining qty after ingredient value is set
            // qty_received: item.qty_received,
            cumulative_sum: item.qty??0, // Start the cumulative sum with ingredient_value
            uoq_id: item.uoq_id, // Start the cumulative sum with ingredient_value
            order_id: item.header_id, // Start the cumulative sum with ingredient_value
            order_no: item.order_no, // Start the cumulative sum with ingredient_value
            delivery_date: item.delivery_date, // Start the cumulative sum with ingredient_value
          };
          return acc;
        }, {});
        setEditableRows(initialEditableState);
         console.log("initial", initialEditableState)
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    if (locationId) {
      fetchDataForDate(selectedDate? selectedDate : startDate);
    }
  }, [startDate,  selectedDate, locationId]);

  const handleOrderQtyChange = (index, value) => {
    setEditableRows((prev) => {
      const updatedRows = { ...prev };
      updatedRows[index] = { ...updatedRows[index], edited_qty: value };
      return updatedRows;
    });
  };

  const calculateEditableQtyAndRemainingQty = (index, data) => {
    let editableQty, remainingQty, cumulativeSum;

    for (let i = 0; i <= index; i++) {    
      if (i > 0 && data[i].ingredient_name !== data[i - 1].ingredient_name) {
      cumulativeSum = (data[index].qty_received, editableRows[i].edited_qty);} else 
      cumulativeSum = parseInt(cumulativeSum? cumulativeSum : 0) + parseInt(editableRows[i]?.edited_qty );
    }
  
    // For the first row or when ingredient_name changes:
    // if (index === 0 || data[index - 1].ingredient_name !== data[index].ingredient_name) {
    //   editableQty = Math.min(data[index].qty_received, data[index].ingredient_value); // First row: Min of qty_received and ingredient_value
    //   remainingQty = (data[index].qty_received - cumulativeSum); // Remaining quantity after first row's edited_qty
    // } else {
      // For subsequent rows:
      // editable_qty is determined based on the previous remaining_qty and ingredient_value
      editableQty = Math.min(editableRows[index - 1]?.remaining_qty, data[index].qty); // Max between previous remaining qty and ingredient_value
      
      
      // Calculate cumulative sum for the current row
      
      // Calculate remaining qty after deducting cumulative sum
      remainingQty = (data[index]?.qty_received - cumulativeSum); // Calculate remaining qty
    // }
  
    return { editableQty, remainingQty, cumulativeSum };
  };
  
  const handleSubmit = async () => {
    const editedData = Object.values(editableRows).map((row) => ({
      id: row.id,
      order_id: row.order_id,
      qty: row.edited_qty, // Submit raw numeric value
      qty_received: row.edited_qty, // Submit raw numeric value
      location_id: locationId, // Submit raw numeric value
      ingredient_id: row.ingredient_id, // Submit raw numeric value
      kitchen_id: row.kitchen_id, // Submit raw numeric value
      uoq_id: row.uoq_id, // Submit raw numeric value
      delivery_date: row.delivery_date, // Submit raw numeric value
      admin_id: localStorage.getItem("userAuthentication"), // Submit raw numeric value
    }));
console.log("show",editedData)
    try {
      const response = await instance2.put("/delivery_order", {
        locationId,
        editedData,
      });

      if (response.status === "OK" ) {
        alert("Data submitted successfully");
      } else {
        alert("Submission failed");
      }
    } catch (error) {
      console.error("Error during submission", error);
      alert("An error occurred while submitting the data");
    }
  };
  const handleSubmitAndNavigate = async () => {
    await handleSubmit();
    navigate(`/penerimaanbahansortbydapur?kitchenId=${localStorage.getItem("kitchenId")}&startDate=${localDateString(selectedDate)}&endDate=${localDateString(selectedDate)}`); // Change this route to your desired destination
  };
  const CustomInput = React.forwardRef(({ value, onClick, isOpen }, ref) => (
    <button
      className="flex items-center justify-between w-full px-4 py-2 border rounded-[15px] bg-white"
      onClick={onClick}
      ref={ref}
      type="button"
    >
      <div className="flex items-center gap-2">
        <img src={CalendarIcon} alt="Calendar" className="h-5 w-5 text-gray-500" />
        <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
        <span>
          {new Date(value).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          })}
        </span>
      </div>
      <div
        className={`text-black font-semibold transform transition-transform duration-500 ease-in-out ${
          isOpen ? "rotate-180" : "rotate-0"
        }`}
      >
        ▼
      </div>
    </button>
  ));

  const handleDownloadPDF = async (orderNumber, orderDetails, supplierName, orderDate) => {
    const doc = new jsPDF();
  
    // Embed the Roboto font (add the correct base64 font data here)
    const robotoFont = basecode; // Replace with base64-encoded Roboto font data
    doc.addFileToVFS('Roboto-Regular.ttf', robotoFont);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    doc.setFont('Roboto', 'normal'); // Set default font to Roboto
  
    // Convert local icon to Base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = (err) => reject(err);
      });
  
    // Load icon
    const iconBase64 = await loadImageAsBase64(DapurIcon);
  
    // Title and Supplier Information Block
    const pageWidth = doc.internal.pageSize.width;
    const text = 'PURCHASE ORDER';
    const textWidth = doc.getTextWidth(text);
    const xPosition = (pageWidth - textWidth) / 2;
  
    const addHeader = (doc, pageWidth, supplierName, orderNumber, orderDate) => {
      doc.setFontSize(12);
      doc.text(text, xPosition, 10);
  
      const supplierInfo = {
        Pemasok: supplierName,
        Nomor: orderNumber,
        'Tanggal ': new Date(orderDate).toLocaleDateString('id-ID', {
          year: 'numeric',
          month: 'long',
          day: '2-digit',
        }),
      };
  
      const marginLeft = 10;
      const textYOffset = 20;
      const labelWidth = Math.max(
        ...Object.keys(supplierInfo).map((key) => doc.getTextWidth(`${key}   `))
      );
  
      let yOffset = textYOffset;
      Object.entries(supplierInfo).forEach(([key, value]) => {
        doc.text(`${key}`, marginLeft, yOffset);
        const colonX = marginLeft + labelWidth;
        doc.text(':', colonX, yOffset);
        const valueX = colonX + 2;
        doc.text(value, valueX, yOffset);
  
        yOffset += 5;
      });
  
      const iconWidth = 23;
      const iconHeight = 18;
      const iconX = pageWidth - iconWidth - 10;
      const iconY = textYOffset - 6;
      doc.addImage(iconBase64, 'PNG', iconX, iconY, iconWidth, iconHeight);
    };
  
    let yOffset = 40;
    const totalPageHeight = doc.internal.pageSize.height;
    let pageNumber = 1;
  
    const addFooter = (currentPage, totalPages) => {
      const footerText = `Page ${currentPage} of ${totalPages}`;
      doc.setFontSize(10);
      doc.text(footerText, pageWidth - doc.getTextWidth(footerText) - 10, totalPageHeight - 10);
    };
  
    addHeader(doc, pageWidth, supplierName, orderNumber, orderDate);
  
    // Initialize grand total
let grandTotal = 0;

// Loop through order details
Object.entries(orderDetails).forEach(([deliveryDate, items], index) => {
  const sectionHeight = items.length * 5 + 26;

  // Check for page break
  if (yOffset + sectionHeight > totalPageHeight - 20) {
    doc.addPage();
    yOffset = 40;
    pageNumber += 1;
    addHeader(doc, pageWidth, supplierName, orderNumber, orderDate);
  }

  // Calculate section subtotal
  const sectionSubtotal = items.reduce(
    (sum, item) => sum + (parseFloat(item.price_total) || 0),
    0
  );
  grandTotal += sectionSubtotal; // Add to grand total

  // Draw gray border for the section
  doc.setDrawColor(200, 200, 200);
  doc.rect(10, yOffset, pageWidth - 20, sectionHeight, 'S');

  // Add delivery date
  doc.setFontSize(10);
  doc.text(
    `Delivery Date: ${new Date(deliveryDate).toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    })}`,
    15,
    yOffset + 5
  );

  yOffset += 7;

  // Add table for items
  doc.autoTable({
    startY: yOffset,
    head: [['#', 'Bahan', 'Jumlah', 'Unit', 'Harga/Unit', 'Subtotal']],
    body: items.map((item, index) => [
      `${index + 1}.`,
      item.ingredient_name || '-',
      formatNumber(item.order_qty), // Formatted
      item.uoq_code || '-',
      formatNumber(item.price_unit) || '-', // Formatted
      formatNumber(item.price_total) || '-', // Formatted
    ]),
    columnStyles: {
      0: { halign: 'center', cellWidth: '5%' },
      1: { halign: 'left', cellWidth: 120 },
      2: { halign: 'right', cellWidth: '10%' },
      3: { halign: 'center', cellWidth: '5%' },
      4: { halign: 'right', cellWidth: '10%' },
      5: { halign: 'right', cellWidth: '10%' },
    },
    styles: {
      cellPadding: 1,
      fontSize: 8,
      overflow: 'linebreak',
      font: 'Roboto',
    },
    headStyles: {
      fillColor: [220, 220, 220],
      textColor: [0, 0, 0],
    },
  });

  // Update yOffset for next section
  yOffset = doc.lastAutoTable.finalY + 5;

 // Set font size to 8 for subtotal
doc.setFontSize(8);
doc.text(`Subtotal: ${formatNumber(sectionSubtotal)}`, pageWidth - 60, yOffset);
yOffset += 10; // Adjust yOffset for next section
});

// Display grand total
doc.text(`Grand Total: ${formatNumber(grandTotal)}`, pageWidth - 60, yOffset);
    
  
    const pageCount = doc.internal.getNumberOfPages();
  
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addFooter(i, pageCount);
    }
  
    doc.save(`${orderNumber}.pdf`);
  };

  return (
    <div className="p-10 flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4">
        <div className="border-t border-gray-400 w-full flex-1"></div>
        <div className="flex flex-col w-full">
          <p className="text-3xl font-medium">Penerimaan DO</p>
          </div>
         <div className="flex flex-row w-full items-center justify-start">
          <div className="font-semibold">Tanggal:</div>
          <DatePicker
            selected={selectedDate? selectedDate : startDate}
            onChange={(date) => setSelectedDate(date)}
            customInput={
              <CustomInput
                value={selectedDate? selectedDate : startDate.toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
                isOpen={isOpen}
              />
            }
            onCalendarOpen={() => setIsOpen(true)}
            onCalendarClose={() => setIsOpen(false)}
            dateFormat="yyyy-MM-dd"
            filterDate={(date) => {
              const day = date.getDay();
              return day !== 0 && day !== 6; // Disable weekends
            }}
          />
        </div>
          <button
          className="w-1/2 px-3 py-2 bg-merah-no text-white rounded-[50px] hover:bg-merah-hover uppercase"
          onClick={handleSubmitAndNavigate}
        >
          Terima Delivery Order
        </button>
        
        <div className="border-t border-gray-400 w-full flex-1"></div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="overflow-x-auto">
          {data.length > 0 ? (
            <table className="fixed-table border-collapse w-full text-left">
              <thead>
                <tr className="bg-white">
                  <th className="border-b w-1/2 border-gray-400 px-4 py-2 uppercase rounded-tl-[15px]">bahan</th>
                  
                  <th className="border-b w-1/4 border-gray-400 px-4 py-2 uppercase text-center" colSpan={2}>Kebutuhan Dapur</th>
                  <th className="border-b w-1/4 border-gray-400 px-4 py-2 uppercase text-center">
                    pengiriman
                  </th><th className="border-b w-1/4 border-gray-400 px-4 py-2 uppercase text-center">
                    penerimaan
                  </th>
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-center">
                    Selisih
                  </th>
                  {/* <th className="border-b border-gray-400 px-4 py-2 uppercase text-center rounded-tr-[15px]">
                    Download PDF
                  </th> */}
                </tr>
              </thead>
              <tbody>
  {Object.values(
    data.reduce((groups, item, index) => {
      // Group data by `ingredient_name`
      if (!groups[item.ingredient_name]) {
        groups[item.ingredient_name] = [];
      }
      groups[item.ingredient_name].push({ ...item, index });
      return groups;
    }, {})
  ).map((group, groupIndex) => {
    // Determine the background color for the group
    const bgColor = groupIndex % 2 === 0 ? "bg-gray-200" : "bg-white";

    return group.map((item, index) => {
      const isFirstRow = index === 0;
      const rowSpan = group.length;

      return (
        <tr key={item.index} className={`${bgColor} bg-opacity-50`}>
          {/* Render ingredient_name only in the first row of the group */}
          {isFirstRow && (
            <td
              className="border-t border-b border-gray-400 px-4 py-2"
              rowSpan={rowSpan}
            >
              {item.ingredient_name}
            </td>
          )}
{/* 
          <td className="border-b border-gray-400 px-4 py-2">
            {item.kitchen_name}
          </td> */}

          <td className="border-b border-gray-400 px-4 py-2">
            {localDateString(new Date(item.delivery_date))}
          </td>

          <td className="border-b border-gray-400 px-4 py-2 text-right">
            {formatNumber(item.qty)}
          </td>
          
<td className="border-t border-b border-gray-400 px-4 py-2 text-center">
  {formatNumber(
    item.order_qty
    //  -
    // (editableRows[item.index]?.edited_qty ??
    //   calculateEditableQtyAndRemainingQty(item.index, data).editableQty)
  )}
</td>

          <td className="border-b border-gray-400 px-4 py-2">
            <input
              type="text"
              value={formatNumber(
                item.qty ??
                editableRows[item.index]?.qty ?? calculateEditableQtyAndRemainingQty(item.index, data).editableQty
              )}
              className="border rounded px-2 py-1 text-right"
              onChange={(e) => {
                const rawValue = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
                const numericValue = parseInt(rawValue, 10) || 0; // Parse as integer
                handleOrderQtyChange(item.index, numericValue); // Update the raw value in state
              }}
            />
          </td>


<td className="border-t border-b border-gray-400 px-4 py-2 text-center">
  {formatNumber(
    item.qty 
    -
    (item.qty ?? editableRows[item.index]?.edited_qty ??
      calculateEditableQtyAndRemainingQty(item.index, data).editableQty
    )
  )}
</td>
{/* 
{(index === 0 || data[index - 1].ingredient_name !== item.ingredient_name) && (
  <td
    className="border-t border-b border-gray-400 px-4 py-2 text-center"
    rowSpan={data.filter(d => d.ingredient_name === item.ingredient_name).length}
  >
    <button
      className="px-4 py-2 bg-blue-500 text-white rounded"
      onClick={() => {
        // Group all rows with the same ingredient name
        const groupItems = data.filter(d => d.ingredient_name === item.ingredient_name);
        handleDownloadPDF(groupItems);
      }}
    >
      Download PDF
    </button>
  </td> 
)}*/}
                    </tr>
      );
    });
  })}
              </tbody>
            </table>
          ) : (
            <p>No data available for the selected date.</p>
          )}
        </div>
      )}

      
    </div>
  );
}
